import { useField } from 'formik'
import TextareaAutosize from 'react-textarea-autosize'
import { TFieldChangePayload } from '../../../../store/managePost/newTypes'

import './TextArea.scss'

type TPostTextChange = (data: TFieldChangePayload) => any

const TextAreaInput = ({ label, children, postTextChange, social, ...props }: any) => {
  const [{ onChange, ...field }, meta] = useField(props)

  const handleChange = (event: React.ChangeEvent<{ value: string }>) => {
    ;(postTextChange as TPostTextChange)({
      value: event.target.value,
      socialNetwork: social,
      field: field.name as any
    })
    onChange(event)
  }
  return (
    <>
      <div className={`textarea-input ${meta.touched && meta.error && 'error'}`}>
        <TextareaAutosize
          className={`textarea-input__input`}
          {...props}
          {...field}
          onChange={handleChange}
        />
        {children}
        {meta.touched && meta.error && (
          <div className='validation-error'>
            <div className='validation-error__icon'></div>
            {meta.error}
          </div>
        )}
      </div>
    </>
  )
}

export default TextAreaInput
